import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { PusherChannel } from "@activecollab/activecollab-react-pusher";
import PropTypes from "prop-types";
import { makeLoggedUserRealTimeChannelNameSelector } from "~/store/selectors/selector.realTime";

export const UserRealTimeChannel = ({ children }) => {
  const getLoggedUserRealTimeChannelName = useMemo(makeLoggedUserRealTimeChannelNameSelector, []);
  const channelName = useSelector(getLoggedUserRealTimeChannelName);

  return <PusherChannel name={channelName}>{children}</PusherChannel>;
};

UserRealTimeChannel.propTypes = {
  children: PropTypes.node,
};
